var blue = {
  100: '#F9FCFF',
  200: '#D7E9FE',
  300: '#B6D6FE',
  400: '#79B4FB',
  500: '#4A97F6',
  600: '#2880EB',
  700: '#1268D1',
  800: '#043C80',
  900: '#001126'
};
export default blue;